/**
 * Helper to check if the current pathname is part of the loan flow.
 * Matches: /loan, /loan-application, /identity-verification, /phone-verification, /verification
 */
export const isLoanFlow = (pathname: string): boolean => {
    return (
        pathname.startsWith('/loan') ||
        pathname.startsWith('/verification') ||
        pathname.startsWith('/identity-verification') ||
        pathname.startsWith('/phone-verification')
    );
};
